import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import NavbarStandard from "../navbar/NavbarStandard";
import Banner from "./Banner";
import Services from "./Services";
import { useHistory } from "react-router";
import Testimonial from "./Testimonial";
import FooterStandard from "./FooterStandard";
import { useSelector } from "react-redux";
import Calculator from "./pages/Calculator";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import "animate.css";

const Landing = ({ location, match }) => {
  const history = useHistory();
  const [showButton, setShowButton] = useState(true);

  document.title = "Homelan | App";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const { isLogged, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isLogged) {
      history.push("/dashboard/app");
    } else {
      history.push("/register");
    }

    // eslint-disable-next-line
  }, [isLogged]);

  useEffect(() => {
    isLogged && user && user.role === "root" && history.push("/root");
    isLogged && user && user.role === "provider" && history.push("/provider");
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    let isMounted = true;
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 700) {
        isMounted && setShowButton(true);
      } else {
        isMounted && setShowButton(false);
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <span id="top"></span>
      <NavbarStandard location={location} match={match} />
      <Banner />
      <Services all={true} cols={4} />
      <Calculator />
      <Faq />
      <Contact />
      <Testimonial />
      <FooterStandard />
      {/*  {showButton && (
        <Link
          className="btn btn-light btn- cursor-pointer position-fixed animate__animated animate__bounceIn"
          to="top"
          style={{
            bottom: "2pc",
            right: "2pc",
            boxShadow: "3px 3px 10px #300140",
          }}
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </Link>
      )} */}
    </>
  );
};

Landing.propTypes = { location: PropTypes.object.isRequired };

export default Landing;
